<div class="c-bui-tooltip-icon">
  <app-bui-icon-container [matTooltip]="tooltip"
    [name]="'information-outline'"
    [inline]="true"
    [size]="IconSizesEnum.XS">
  </app-bui-icon-container>
</div>
